import React, { useState } from "react";
import VidyardPlayer from "../components/VidyardPlayer";

interface LearningCoachCardProps {
  schoolName: string;
  title: string;
  description: string;
  vidyardUuid?: string;
  additionalContent: React.ReactNode;
  gradeRange: any;
}

const LearningCoachRoleSchoolCard: React.FC<LearningCoachCardProps> = ({
  schoolName,
  title,
  description,
  vidyardUuid,
  additionalContent,
  gradeRange
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <div className="wp-block-k12-school-content-wrapper mb-4 mb-md-0">
      <div className="wp-block-k12-section container-fluid bg-color-light-gray-3 p-4">
        <div className="row">
          <div className="col-12">
            <div className="wp-block-k12-content-block">
              <div className="row p-2rem">
                <div className="col-12 d-flex flex-column gap-2 order-1">
                  <p className="eyebrow">
                    <strong>{schoolName}</strong>
                  </p>
                  <h2>{title}</h2>
                  <p>{description}</p>
                </div>
              </div>
            </div>

            {/* Accordion Section */}
            <div className="wp-block-k12-show-more-block">
              <div className="accordion">
                <div className="accordion-item">
                  <div className={`accordion-collapse collapse ${isExpanded ? "show" : ""}`}>
                    <div className="accordion-body bg-transparent p-0 p-sm-2rem">
                      <div className="wp-block-k12-section container-fluid bg-color-white p-4">
                        <div className="row">
                          <div className="col-12 g-0">
                            <h3 className="wp-block-heading text-center">
                              Your Day as a {gradeRange} Learning Coach
                            </h3>

                            {/* Vidyard Player if available */}
                            {vidyardUuid && (
                              <div className="wp-block-k12-video-block1">
                                <VidyardPlayer uuid={vidyardUuid} type="lightbox" />
                              </div>
                            )}

                            {additionalContent}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <button className="accordion-button" type="button" onClick={toggleExpand}>
                    <span className="show-more">
                      {isExpanded ? "Show Less" : "Show More"}
                    </span>
                  </button>
                </div>
              </div>
            </div>
            {/* End Accordion Section */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LearningCoachRoleSchoolCard;
